<template>
  <div class="c-white-background">
    <!-- <MainNavBarWapV2 :object-data="infoHeader" /> -->
    <div class="top-spacing container column">
      <TablePriceFacility :is-vietinbank="true" />
    </div>
  </div>
</template>
<script>
import { getBackGround } from "@/utils/wapAuth";
// import MainNavBarWapV2 from "../../../../layout/WapV2/MainNavBar.vue";
import TablePriceFacility from "./TablePriceFacility.vue";
export default {
  components: {
    // MainNavBarWapV2,
    TablePriceFacility
  },
  name: "price-booking",
  props: {
    isShow: {
      type: Boolean,
      default: true
    }
  },
  created() {},
  data() {
    return {
      infoHeader: {
        title: this.$t("wap.text134"),
        isShowHomeIcon: true
      },
      bg: getBackGround()
    };
  },
  watch: {},
  computed: {},
  methods: {}
};
</script>
<style>
@media screen and (min-width: 0px) and (max-width: 480px) {
}
</style>

<style lang="scss" scoped>
.column {
  flex-direction: column;
}

.desktop {
  display: block;
}

.mobile {
  display: none;
}

.top-spacing {
  padding-top: 40px;
}
@media screen and (min-width: 0px) and (max-width: 480px) {
}
@media screen and (min-width: 0px) and (max-width: 769px) {
  .text-hotline {
    font-size: 12px;
  }

  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
  .top-spacing {
    padding-top: 65px;
  }
}
@media screen and (min-width: 0px) and (max-width: 980px) {
  .title-section {
    display: none;
  }
}
</style>
